<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <error-msg-component :messages="messagesPopup"
                           :error="isErrorPopup"
                           :title="'general.problemOccurred'"
                           :withEmplyFields="true"
                           @close="isErrorPopup = $event"/>
      <div class="card-content columns is-marginless is-multiline">
        <section class="has-text-centered column is-12 is-paddingless mgt-20px">
          <b-icon type="is-warning" icon="alert-outline" class="icon-modal is-marginless"></b-icon>
        </section>
        <section class="has-text-centered column is-12 is-paddingless mgt-20px ">
          <span class="is-size-5 has-text-weight-bold">
            {{$i18n.t('detail.popUpCloture.mess')}}
          </span>
        </section>
        <div class="column is-12 is-paddingless mgt-20px">
          <b-field :label="$t('detail.popUpCloture.closingDate')"
            class="obligatoire is-marginless"
            :type="dateHasError">
              <b-datepicker show-week-number
                icon="calendar-today"
                :editable="true"
                nearby-selectable-month-days
                v-model="dateCloture">
              </b-datepicker>
          </b-field>
        </div>
        <main class="column is-12 is-paddingless mgt-20px">
          <div class="has-text-centered mgt-20px">
              <button
                class="button btn-modal-annuler is-cancel has-text-centered
                  button-modal"
                @click="annuler">
                {{$i18n.t('detail.popUpCloture.cancel')}}
              </button>
              <button class="button is-warning has-text-centered button-modal"
                      @click="cloture">
                {{$i18n.t('detail.popUpCloture.close')}}
              </button>
            </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import errorMsgComponent from '@/components/general/errorMsgComponent';

export default {
  name: 'popupCloture',
  props: {
    messagesPopup: Array,
    isErrorPopup: Boolean,
  },
  components: {
    errorMsgComponent,
  },
  data() {
    return {
      dateCloture: null,
      error: false,
    };
  },
  computed: {
    dateHasError() {
      return this.error && !this.dateCloture ? 'is-danger' : '';
    },
  },
  methods: {
    cloture() {
      if (!this.dateCloture) this.error = true;
      this.$emit('cloture', this.dateCloture);
    },
    annuler() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>

</style>
